
// --- Start of new loadWebpackScript (replaces the old jQuery version) ---
(function (window, document) {
    'use strict';

    // Keep track of loaded scripts and scripts currently being loaded to avoid duplicates
    // and to manage callbacks correctly.
    if (!window.McGlobalWebpackState) {
        window.McGlobalWebpackState = {
            loadedScripts: new Set(), // URLs of scripts that have successfully loaded
            loadingScripts: {}        // scriptUrl -> array of callbacks for scripts currently in flight
        };
    }

    // Returns true if a <script> with the same resolved path is already present in the document.
    // Server-rendered entrypoints (e.g. the master's blocking <script src> tags) are NOT tracked
    // in McGlobalWebpackState, so without this check loadWebpackScript would re-append and
    // re-execute them. Re-executing the shared runtime chunk (webpack runtimeChunk:'single' -> a
    // single runtime.js shared by every entrypoint) re-initialises the webpack runtime and wipes
    // the record of already-installed chunks, which intermittently prevents a lazily-loaded
    // entrypoint (the favourites-history dialog, SO 216629) from ever executing -> its entry
    // function is never defined and its button never appears until a refresh. Treating an
    // already-present script as loaded avoids that. Any server-rendered script is a blocking tag
    // in <head>, so by the time a lazy load runs (post-DOMContentLoaded) it has fully executed.
    function isScriptAlreadyInDom(scriptUrl) {
        try {
            var wantedPath = new URL(scriptUrl, document.baseURI).pathname;
            var existing = document.getElementsByTagName('script');
            for (var i = 0; i < existing.length; i++) {
                var src = existing[i].getAttribute('src');
                if (!src) continue;
                if (new URL(src, document.baseURI).pathname === wantedPath) {
                    return true;
                }
            }
        } catch (e) {
            // URL parsing can throw on very old engines; fall back to loading normally.
            console.warn('loadWebpackScript: could not check for existing script ' + scriptUrl, e);
        }
        return false;
    }

    window.loadWebpackScript = function (scriptUrl, callback) {
        if (!scriptUrl) {
            console.error('loadWebpackScript: scriptUrl is required.');
            if (callback) callback(new Error('scriptUrl is required')); // Call callback with error
            return;
        }

        // 1. If script is already loaded, execute callback immediately.
        if (window.McGlobalWebpackState.loadedScripts.has(scriptUrl)) {
            if (callback) {
                // Ensure callback is called asynchronously to maintain consistent behavior
                // with cases where the script is actually loaded.
                setTimeout(function () { callback(); }, 0);
            }
            return;
        }

        // 2. If script is currently being loaded, add this callback to its queue.
        if (window.McGlobalWebpackState.loadingScripts[scriptUrl]) {
            if (callback) {
                window.McGlobalWebpackState.loadingScripts[scriptUrl].push(callback);
            }
            return;
        }

        // 2b. If the script is already on the page (server-rendered blocking tag we never tracked),
        // treat it as loaded rather than re-appending and re-executing it. See isScriptAlreadyInDom.
        if (isScriptAlreadyInDom(scriptUrl)) {
            window.McGlobalWebpackState.loadedScripts.add(scriptUrl);
            if (callback) {
                setTimeout(function () { callback(); }, 0);
            }
            return;
        }

        // 3. Script is not loaded and not currently loading: initiate loading.
        window.McGlobalWebpackState.loadingScripts[scriptUrl] = [];
        if (callback) {
            window.McGlobalWebpackState.loadingScripts[scriptUrl].push(callback);
        }

        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.src = scriptUrl;
        scriptElement.async = true;

        const executeCallbacks = function (error) {
            const callbacks = window.McGlobalWebpackState.loadingScripts[scriptUrl];
            if (callbacks) {
                callbacks.forEach(function (cb) {
                    if (cb) {
                        try {
                            cb(error || null); // Pass error if one occurred
                        } catch (e) {
                            console.error('Error in loadWebpackScript callback for ' + scriptUrl, e);
                        }
                    }
                });
            }
            delete window.McGlobalWebpackState.loadingScripts[scriptUrl];
        };

        scriptElement.onload = function () {
            window.McGlobalWebpackState.loadedScripts.add(scriptUrl);
            executeCallbacks(null); // No error
        };

        scriptElement.onerror = function () {
            const errorMsg = 'Failed to load webpack script: ' + scriptUrl;
            console.error(errorMsg);
            executeCallbacks(new Error(errorMsg));
        };

        (document.head || document.getElementsByTagName('head')[0] || document.documentElement).appendChild(scriptElement);
    };

})(window, document);

// File: McWebpackLoader.js
(function (window, document) {
    'use strict';

    if (window.McWebpackLoader) {
        return; // Already defined
    }

    window.McWebpackLoader = {
        /**
         * Loads an array of script URLs sequentially and then executes a final callback.
         * Assumes a global function 'loadWebpackScript(scriptUrl, successCallback)' exists.
         * @param {string[]} scriptUrls - Array of script URLs to load.
         * @param {function} finalCallback - Function to execute after all scripts are loaded.
         * @param {object} [context=null] - Optional 'this' context for the finalCallback.
         */
        loadScriptsAndRun: function (scriptUrls, finalCallback, context) {
            let index = 0;
            context = context || null;

            function loadNext() {
                if (index >= scriptUrls.length) {
                    if (finalCallback) {
                        finalCallback.call(context);
                    }
                    return;
                }

                let scriptUrl = scriptUrls[index];
                index++;

                if (typeof window.loadWebpackScript === 'function') {
                    // Assuming loadWebpackScript calls its callback upon successful load.
                    // If it also needs an error callback, that should be handled here.
                    window.loadWebpackScript(scriptUrl, function () {
                        loadNext();
                    });
                } else {
                    console.error('Global function loadWebpackScript is not defined. Cannot load: ' + scriptUrl);
                    // Optionally, try to load the script using a simple script tag as a fallback,
                    // but this won't guarantee sequential execution without more complex handling.
                    // For now, just log error and proceed.
                    loadNext();
                }
            }
            loadNext();
        },

        /**
         * Executes a callback function once the DOM is ready.
         * @param {function} callback - The function to execute.
         * @param {object} [context=null] - Optional 'this' context for the callback.
         */
        executeWhenReady: function (callback, context) {
            context = context || null;
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
                // DOM is already ready or fully loaded
                callback.call(context);
            } else {
                // Wait for DOMContentLoaded
                document.addEventListener('DOMContentLoaded', function () {
                    callback.call(context);
                });
            }
        }
    };
})(window, document);